import React from 'react';
import {
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Sort as SortIcon,
  Clear as ClearIcon,
} from '@mui/icons-material';
import '../../../../components/clients/mobile/styles/MobileClients.css';

/**
 * Clients-style mobile search row: filter + sort affordances in the search bar.
 */
const MobileEmployeeSearchHeader = ({
  searchTerm,
  onSearchChange,
  onFilterClick,
  onSortClick,
  totalEmployees = 0,
  countPillLabel = '',
  hasRoleFilter = false,
  selectedRoleLabel = '',
  onClearRoleFilter,
}) => {
  const pillText =
    countPillLabel || (totalEmployees != null ? String(totalEmployees) : '');
  return (
    <div className="mobile-clients-search-header mobile-employee-search-header">
      <div className="mobile-clients-search-header__top">
        <h2 className="mobile-clients-title">Employee Management</h2>
        <span className="mobile-clients-count-pill">{pillText}</span>
      </div>

      <div className="mobile-clients-search-bar">
        <div className="mobile-clients-icon-button">
          <SearchIcon fontSize="small" />
        </div>
        <input
          className="mobile-clients-search-input"
          type="search"
          placeholder="Search employees…"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {searchTerm ? (
          <button
            type="button"
            className="mobile-clients-icon-button"
            onClick={() => onSearchChange('')}
            aria-label="Clear search"
          >
            <ClearIcon fontSize="small" />
          </button>
        ) : null}
        <button
          type="button"
          className={
            'mobile-clients-icon-button' +
            (hasRoleFilter ? ' mobile-clients-icon-button--filter-active' : '')
          }
          onClick={onFilterClick}
          aria-label="Filter by role"
        >
          <span className={hasRoleFilter ? 'mobile-clients-icon-badge-dot' : ''}>
            <FilterListIcon fontSize="small" />
          </span>
        </button>
        <button
          type="button"
          className="mobile-clients-icon-button"
          onClick={onSortClick}
          aria-label="Sort team"
        >
          <SortIcon fontSize="small" />
        </button>
      </div>

      {hasRoleFilter && selectedRoleLabel ? (
        <div className="mobile-clients-selected-filter">
          <span>Filtered by:</span>
          <span className="mobile-clients-selected-filter-pill">
            {selectedRoleLabel}
            <button type="button" onClick={onClearRoleFilter} aria-label="Clear role filter">
              <ClearIcon fontSize="small" />
            </button>
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default MobileEmployeeSearchHeader;
